import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function OtherProposals() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("Other Proposals")}</legend>
      <input
        name="otherProposals"
        onChange={onChange}
        value={searchObject.otherProposals || ""}
        className="form-control"
      />
    </fieldset>
  );
}
